import { useEffect, useState } from "react";
import { useLocation, useNavigate, Outlet } from "react-router-dom";
import PageContainer from "../../Components/Page/PageContainer";
import { TabMenu } from "primereact/tabmenu";
import { Card } from "primereact/card";
import NewIssuesBanner from "../../Components/NewIssuesBanner/NewIssuesBanner";

import { ROUTES } from "../../config/routes";

const Scrapers = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [activeIndex, setActiveIndex] = useState<number>(0);

  // Sync active tab with current route
  useEffect(() => {
    const path = location.pathname;
    // Set active tab based on current route
    if (path.includes(ROUTES.MUSIC_ASSET_SCRAPER_EXPLORER)) {
      setActiveIndex(1);
    } else if (path.includes(ROUTES.MUSIC_ASSET_SCRAPER)) {
      setActiveIndex(0);
    } else {
      setActiveIndex(-1); // No tab selected for dashboard
    }
  }, [location.pathname]);

  const handleTabChange = (e: any) => {
    if (e.index === 0) {
      navigate(ROUTES.MUSIC_ASSET_SCRAPER);
    } else if (e.index === 1) {
      navigate(ROUTES.MUSIC_ASSET_SCRAPER_EXPLORER);
    }
  };

  const items = [
    { label: "Music Asset Scraper", icon: "pi pi-microphone" },
    { label: "Music Asset Explorer", icon: "pi pi-database" },
  ];

  return (
    <>
      {/* Real-time notification banner */}
      <NewIssuesBanner
        collections={["DSRHealthMetrics"]}
        position="top"
        showCount={true}
      />

      <PageContainer
        HomeMenuBarprops={{
          title: (
            <span
              style={{ cursor: "pointer", fontWeight: "bold" }}
              onClick={() => navigate(ROUTES.SCRAPERS)}
            >
              Scrapers
            </span>
          ),

          Tabs: (
            <TabMenu
              activeIndex={activeIndex}
              onTabChange={handleTabChange}
              model={items}
            />
          ),
        }}
      >
        <div
          style={{
            width: "96%",
            margin: "0 auto",
          }}
        >
          <Card
            unstyled
            style={{
              marginTop: "2rem",
              boxShadow: "none",
            }}
          >
            {/* Use Outlet for sub-routes */}
            <Outlet />
          </Card>
        </div>
      </PageContainer>
    </>
  );
};

export default Scrapers;
